import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { Icon } from '@evogard/ui';
import { api, ok } from '../lib/api.js';
import { can, useSessionContext } from '../lib/session.js';

/** Os estouros em aberto — o tempo real (`lib/realtime.tsx`) invalida a cada aviso. */
export const BREAK_OVERRUNS_KEY = ['intervalo', 'estouros'] as const;

/**
 * O botão vermelho do topo com quantos intervalos estouraram e ninguém
 * encerrou ou dispensou — o sino do legado (`intervalo-notificacoes-listener`).
 * O clique leva à lista. Para quem tem `breaks.overruns:ver` (a base) e para o
 * líder de departamento (a equipe — a API recorta), e só quando há algum: zero
 * estouros não ocupa o topo.
 */
export function BreakOverrunsBadge() {
  const { data: context } = useSessionContext();
  const tenantId = context?.currentTenant.id;
  const allowed =
    can(context, 'breaks.overruns', 'ver') || can(context, 'breaks.records', 'liderar');

  const query = useQuery({
    queryKey: [...BREAK_OVERRUNS_KEY, tenantId],
    enabled: allowed && tenantId !== undefined,
    queryFn: async () => {
      const r = await api.breaks.overruns();
      // quem tem `liderar` sem liderar setor nenhum recebe 403: não há equipe
      if (r.status === 403) return [];
      return ok(r, 200, 'Não foi possível carregar os estouros.');
    },
    // a rede de segurança do tempo real: o socket pode ter caído
    refetchInterval: 60_000,
  });

  const count = query.data?.length ?? 0;
  if (!allowed || count === 0) return null;

  return (
    <Link
      to="/breaks/overruns"
      aria-label={`${count} intervalo(s) estourado(s) — ver a lista`}
      className="flex h-11 shrink-0 items-center gap-1.5 rounded-borda border-2 border-erro bg-erro-suave px-2.5 text-sm font-semibold text-erro motion-safe:animate-pulse lg:h-[2.125rem]"
    >
      <Icon nome="relogio" />
      {count}
    </Link>
  );
}
